var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"login"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"auth-box"},[_c('user-account-modal',{on:{"loginSuccess":function($event){return _vm.loggedIn()}}})],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }